export const MESSAGE_TEMPLATES = {
  default: "Halo, saya tertarik dengan {product}",
  formal: "Selamat pagi/siang/malam, saya ingin menanyakan tentang {product}",
  promo: "Halo, apakah {product} masih tersedia? Saya tertarik dengan promonya",
  detail: "Halo, bisa info detail dan harga untuk {product}?",
  nego: "Halo, apakah harga {product} bisa nego?",
};